import CryptoJS from 'crypto-js'; 

export const getDeviceInfo = () => {
     const fingerprint = {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        hardwareConcurrency: navigator.hardwareConcurrency,
        deviceMemory: navigator.deviceMemory,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        colorDepth: window.screen.colorDepth,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    return {
        deviceId: CryptoJS.SHA256(JSON.stringify(fingerprint)).toString(),
    };
};

export const getLocation = () => {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
            reject(new Error("Geolocation not supported by this browser."));
            return;
        }

        const options = {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
        };

        const attemptLocation = (retry = false) => {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                },
                (error) => {
                    if (!retry && error.code === 2) {
                        // Retry once after 2 seconds
                        setTimeout(() => attemptLocation(true), 2000);
                    } else {
                        reject(error);
                    }
                },
                options
            );
        };

        attemptLocation();
    });
};


